import { LitElement, html } from 'lit';

/**
 * Letterbox Distribution Link Component
 * Conditionally displays a link to the Sputnik quote viewer for Letterbox quotes
 * Only renders when sputnikQuoteId is provided and environment variable is configured
 */
class LetterboxDistributionLink extends LitElement {
    static properties = {
        sputnikQuoteId: { type: String },
    };

    // Use Light DOM for Tailwind compatibility
    createRenderRoot() {
        return this;
    }

    constructor() {
        super();
        this.sputnikQuoteId = null;
    }

    get shouldShowLink() {
        return this.sputnikQuoteId && import.meta.env.VITE_SPUTNIK_QUOTE_VIEWER_BASE_URL;
    }

    get viewerUrl() {
        const baseUrl = import.meta.env.VITE_SPUTNIK_QUOTE_VIEWER_BASE_URL;
        return `${baseUrl}?${this.sputnikQuoteId}&mode=mapOnly`;
    }

    render() {
        if (!this.shouldShowLink) {
            return html``;
        }

        return html`
            <a
                href="${this.viewerUrl}"
                target="_blank"
                rel="noopener noreferrer"
                class="btn btn-outline btn-sm"
            >
                Review Letterbox Distribution Map
                <svg class="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                    ></path>
                </svg>
            </a>
        `;
    }
}

customElements.define('letterbox-distribution-link', LetterboxDistributionLink);
